import React from 'react'
import Tray from '~/modules/Tray/Video'
import Spinner from '~/components/Spinner'
import lazyLoad from "~/tools/lazy-load-images";
import { SINGULAR_CONTENT_TYPE_OUTPUTS, PLURAL_CONTENT_TYPE_OUTPUTS, contentTypes } from '~/redux/websearch/constant'
import {getResults, getLayout} from '~/redux/websearch/helper'
import { trackEvent } from "~/tools/analytics/cleverTap";
import { trackPageview } from "~/tools/analytics/googleAnalytics"
import ErrorBoundary from '~/components/ErrorBoundary'
import _ from 'lodash'
import './style.css'


class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      searchResults: {},
      settings: {},
      contentTypes: contentTypes
    };
  }

  componentDidMount() {
    this.searchInput.focus();

    getLayout("Search Screen").then(({ moduleList }) => {
      this.setState({ settings: moduleList[0].settings });
    });
  }

  componentDidUpdate() {
    if (!this.state.loading && this.state.searchTerm.length > 0) {
      var searchEventData = {
        keyword: this.state.searchTerm
      }
      trackEvent('Searched', searchEventData);
      trackPageview(
        `/search?searchTerm=${this.state.searchTerm}`
      );
    }
    setTimeout(lazyLoad, 1000);
  }

  render() {
    const hasResults = this.state.totalResults > 0;
    return (
      <div className="search">
        <div
          className={"search-container " + (hasResults ? "has-results" : "")}
        >
          <span className="title">SEARCH</span>
          <div className="search-input">
            <input
              type="text"
              className="search-container-input"
              placeholder="Search..."
              ref={input => {
                this.searchInput = input;
              }}
              onChange={_.debounce(e => this.handleKeyUp(e), 1000)}
            />
          </div>
        </div>
        {this.state.loading && <Spinner />}
        {!this.state.loading &&
          this.state.searchTerm.length > 0 && (
            <div className="search-results">
              {hasResults ? (
                this.renderResults()
              ) : (
                <div className="no-results"> No Results Found </div>
              )}
            </div>
          )}
        <div className={this.getSearchResultsClassNames()}>
          {this.renderMobileResults()}
        </div>
      </div>
    );
  }

  getSearchResultsClassNames() {
    return !_.isEmpty(this.state.searchResults)
      ? "search-results search-results-mobile results"
      : "search-results search-results-mobile";
  }

  renderResults() {
    return _.map(
      this.state.searchResults,
      (contentResults, contentType) =>
        contentResults.length > 0 && (
          <ErrorBoundary>
            <Tray
              key={contentType}
              trayTitle='Search Results'
              data={{
                contentData: contentResults,
                title: PLURAL_CONTENT_TYPE_OUTPUTS[contentType],
                filters: {}
              }}
              layout={{ settings: this.state.settings }}
            />
          </ErrorBoundary>
        )
    );
  }

  renderMobileResults() {
    return _.map(this.state.searchResults, (items, category) => {
      return (
        items.length > 0 &&
        _.map(
          items,
          item =>
            item.contentType === "PERSON"
              ? this.renderMobileTypeahead(item)
              : this.renderMobileTypeahead(item.gist)
        )
      );
    });
  }

  renderMobileTypeahead(item) {
    return (
      item && (
        <a
          href={item.permalink}
          className={
            `search-item ` + (item.contentType === "VIDEO" ? "video-item" : "")
          }
          key={item.id}
        >
          <div className="content-type">
            {SINGULAR_CONTENT_TYPE_OUTPUTS[item.contentType]}
          </div>
          <div className="title">
            {item.title || `${item.firstName} ${item.lastName}`}
          </div>
          {item.contentType === "VIDEO" && (
            <div className="duration">
              {this.renderDuration(item) + " | " + this.renderYear(item)}
            </div>
          )}
        </a>
      )
    );
  }

  renderDuration(item) {
    const runtime = Math.ceil(item.runtime / 60);
    return `${runtime} min${runtime > 1 ? "s" : ""}`;
  }

  renderYear(item) {
    return new Date(item.addedDate).getFullYear();
  }

  handleKeyUp(event) {
    let searchTerm = this.searchInput.value;
    let searchResults = {};
    let totalResults = 0;
    this.setState({ loading: !!searchTerm && searchTerm.length > 0 });
    this.state.contentTypes.forEach(contentType => {
      getResults(searchTerm, contentType).then(r => {
        if (r) {
          searchResults[`${contentType}`] = r.data;
          totalResults += r.data.length;
        }
        if (Object.keys(searchResults).length === 7) {
          this.setState({
            loading: false,
            searchResults: searchResults,
            searchTerm: searchTerm,
            totalResults: totalResults
          });
        }
      });
    });
  }
}

export default Search
